import React from 'react'
import './AboutUs.css'
import Lady_holding_phone from '../../assests/Rectangle 1017.png'


const AboutUs = () => {
  return (
    <div className='about-us'>
      <div className="about-left">
        <div className="about-left-badge">
            <p className='badge-text'>About Us</p>
        </div>
        <h2>Simplifying Payments, <br /> Empowering Lives</h2>
        <p className='about-left-text'>
            <span>Sendcheap</span> is a leading payment solutions provider committed to making 
            financial transactions easy, secure, and accessible for everyone. We 
            offer a wide range of services, including offline bill payments, virtual 
            cards, and bulk payments, designed to meet the needs of both individuals 
            and businesses.
        </p>
        <p className='about-left-text'>
            Our mission is to revolutionize the way people and businesses make payments. Through 
            our innovative platform and extensive agent network, we strive to provide convenient 
            and efficient payment solutions that empower our customers to achieve their financial goals.
        </p>
      </div>
      <div className="about-right">
        <img src={Lady_holding_phone} alt="" />
      </div>
    </div>
  )
}

export default AboutUs
